"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DashboardClient = void 0;
const Dashboard_1 = require("./Dashboard");
const ClientAccountsServiceClient_1 = require("./ClientAccountsServiceClient");
class DashboardClient {
    constructor(baseUrl, authService, logger = null, apiConfig) {
        this.clientAccountsClient = new ClientAccountsServiceClient_1.ClientAccountsServiceClient(baseUrl, authService, logger, apiConfig);
    }
    getDashboard(scope, scopeKeys) {
        return __awaiter(this, void 0, void 0, function* () {
            const clientAccounts = yield this.clientAccountsClient.getAllClientAccountsAsync(scope, scopeKeys);
            const clientAccountsPromises = clientAccounts.map((item) => {
                return this.clientAccountsClient.getClientAccountAsync(item.clientAccountKey, true, false);
            });
            const clientAccountDetailsArray = yield Promise.all(clientAccountsPromises);
            const dashboard = new Dashboard_1.Dashboard();
            for (const clientAccount of clientAccountDetailsArray) {
                const key = clientAccount.clientAccountKey;
                const clientAccountDetail = yield this.clientAccountsClient.getClientAccountAsync(key, true, false);
                if (!dashboard.name && clientAccountDetail.name) {
                    dashboard.name = clientAccountDetail.name;
                }
                if (!dashboard.adviser && clientAccountDetail.adviser) {
                    dashboard.adviser = clientAccountDetail.adviser;
                }
                if (clientAccountDetail.currentValue) {
                    dashboard.currentValue += clientAccountDetail.currentValue;
                }
                if (clientAccountDetail.totalReturnValue) {
                    dashboard.totalReturnValue += clientAccountDetail.totalReturnValue;
                }
                if (clientAccountDetail.portfolios) {
                    dashboard.portfolios.push(...clientAccountDetail.portfolios);
                }
                if (clientAccountDetail.inceptionDate) {
                    const inceptionDate = new Date(clientAccountDetail.inceptionDate);
                    dashboard.inceptionDate = dashboard.inceptionDate != undefined
                        && dashboard.inceptionDate < inceptionDate
                        ? dashboard.inceptionDate : inceptionDate;
                }
                dashboard.valueOverTimeList = this.mergeValueOverTime(dashboard.valueOverTimeList, clientAccountDetail.valueOverTime);
            }
            return dashboard;
        });
    }
    mergeValueOverTime(first, second) {
        if (first.length == 0) {
            return second;
        }
        if (second.length == 0) {
            return first;
        }
        let merged;
        let toBeMerged;
        if (first.length >= second.length) {
            merged = first;
            toBeMerged = second;
        }
        else {
            merged = second;
            toBeMerged = first;
        }
        for (let i = 0; i < toBeMerged.length; i++) {
            const valueOverTimeFromMerged = merged.find(x => x.date == toBeMerged[i].date);
            if (valueOverTimeFromMerged != undefined) {
                valueOverTimeFromMerged.value = valueOverTimeFromMerged.value + toBeMerged[i].value;
            }
            else {
                merged.push(toBeMerged[i]);
            }
        }
        return merged.sort((a, b) => a.date < b.date ? -1 : a.date > b.date ? 1 : 0);
    }
}
exports.DashboardClient = DashboardClient;
